module.exports = __webpack_public_path__ + "../resources/img/ic_in_progress_number_5.8c95491c.svg";